import { Outlet } from 'react-router-dom';

export type ServicionsModuleProps = {};

const ServicionsModule: React.FC<ServicionsModuleProps> = () => {
  return (
    <Outlet />
  );
};

export default ServicionsModule;
